import { getCall, postCall } from './service';

export function updateUser({ userId, ownerId, promoCode }: { userId: string, ownerId?: string, promoCode?: string }) {
  return postCall('/api/user/update', { userId, ownerId, promoCode });
};


export function getUserInfo( userId: string) { 
  return getCall('/api/user/getUserInfo', {userId});
};